import React, { ReactNode } from 'react'
import Tag from '../Tag'

const FilterValue = ({ children }: { children: ReactNode }) => (
  <Tag color="#7B7E80">{children}</Tag>
)

export default FilterValue
